import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createBlock(_component_van_tabbar, {
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active = $event),
    class: "navBar"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      icon: $data.home_ico,
      class: "navItem"
    }, {
      default: _withCtx(() => [_createTextVNode("主页")]),
      _: 1
    }, 8, ["icon"]), _createVNode(_component_van_tabbar_item, {
      icon: $data.user_ico,
      class: "navItem"
    }, {
      default: _withCtx(() => [_createTextVNode("我的")]),
      _: 1
    }, 8, ["icon"])]),
    _: 1
  }, 8, ["modelValue"]);
}